export default __webpack_public_path__ + "static/media/elle-herron.06a16df8.png";